import { render, staticRenderFns } from "./AuthenticatePhoneMeliCodeInput.vue?vue&type=template&id=b18604a4&scoped=true"
import script from "./AuthenticatePhoneMeliCodeInput.vue?vue&type=script&lang=js"
export * from "./AuthenticatePhoneMeliCodeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18604a4",
  null
  
)

export default component.exports